import { BillingTypeTerm, OptionType } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import type { PriceObjectZodSchemaType } from "@/components/features/_shared/validation-schema/validation-schema";

import type { FormOptionType } from "@/components/ui/form/_types/type";

type PriceObjectType = ForAutoGenerator<PriceObjectZodSchemaType, "">;

type Props = {
	price: PriceObjectType;
	billingTypeTerm: ForNodeType<BillingTypeTerm>; //
	optionType: ForNodeType<OptionType>;

	onSetViewModel: (
		values: {
			key: "price" | "billingTypeTerm";
			value: PriceObjectType | ForNodeType<BillingTypeTerm>;
		}[],
	) => void;
};

export const useOptionPrice = ({ price, billingTypeTerm, optionType, onSetViewModel }: Props) => {
	const onSetPriceAmount = (input: number | undefined) => {
		onSetViewModel([
			{
				key: "price",
				value: {
					...price,
					amount: {
						isEdited: true,
						value: input!,
					},
				},
			},
		]);
	};

	const shouldShowBillingTypeTerm = optionType.value === OptionType.Service;

	const billingTypeTermOptions = [
		{
			id: "option_saleTypeForTerm_0",
			label: "１泊ごとに",
			value: BillingTypeTerm.PerDate,
		},
		{
			id: "option_saleTypeForTerm_1",
			label: "宿泊を通して",
			value: BillingTypeTerm.PerReservation,
		},
	] satisfies FormOptionType[];

	const onSetBillingTypeTerm = (input: string) => {
		onSetViewModel([
			{
				key: "billingTypeTerm",
				value: {
					...billingTypeTerm,
					value: input as BillingTypeTerm,
				},
			},
		]);
	};

	const isEdited = price.amount?.isEdited || billingTypeTerm.isEdited || false;
	const hasError = Boolean(price.amount?.error || billingTypeTerm.error || false);

	return {
		isEdited,
		hasError,

		price,
		onSetPriceAmount,

		billingTypeTerm,
		shouldShowBillingTypeTerm,
		onSetBillingTypeTerm,
		billingTypeTermOptions,
	};
};
